module.exports = __webpack_public_path__ + "static/img/6bg_9.260bcaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_9.png
// module id = 735
// module chunks = 1